export const ADULTS = "adults";
export const LAP_CHILDREN = "lapChildren";
export const OLDER_CHILD = "olderChild";
export const TEENS = "teens";
export const YOUNGER_CHILD = "youngerChild";
